module.exports = __webpack_public_path__ + "img/no_network_alert.283c4417.png";